import { Component, OnInit } from '@angular/core';
import { MatDialogRef} from '@angular/material/dialog'

@Component({
  selector: 'app-add-applicant-info-dialog',
  templateUrl: './add-applicant-info-dialog.component.html',
  styleUrls: ['./add-applicant-info-dialog.component.css']
})
export class AddApplicantInfoDialogComponent implements OnInit {

  model = {FirstName: '', LastName: '', Email: ''};

  constructor(public dialogRef: MatDialogRef<AddApplicantInfoDialogComponent>) { }

  ngOnInit(): void {
  }

  onSubmit(){
    this.dialogRef.close(this.model);
  }

}
